import { render, staticRenderFns } from "./com_complaint.vue?vue&type=template&id=d17fa1f4&scoped=true"
import script from "./com_complaint.vue?vue&type=script&lang=js"
export * from "./com_complaint.vue?vue&type=script&lang=js"
import style0 from "./com_complaint.vue?vue&type=style&index=0&id=d17fa1f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d17fa1f4",
  null
  
)

export default component.exports